var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,4.5a.5.5,0,0,1-.354-.146l-4-4a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0l4,4A.5.5,0,0,1,4,4.5Z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.5a.5.5,0,0,1-.354-.146.5.5,0,0,1,0-.707l4-4a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.707l-4,4A.5.5,0,0,1,0,4.5Z",
    transform: "translate(0 4)",
    fill: "#555"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4,4.5a.5.5,0,0,1-.354-.146l-4-4a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0l4,4A.5.5,0,0,1,4,4.5Z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.5a.5.5,0,0,1-.354-.146.5.5,0,0,1,0-.707l4-4a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.707l-4,4A.5.5,0,0,1,0,4.5Z",
    transform: "translate(0 4)",
    fill: "#555"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double_arrow.d55f0cbf7d69cc66179a0e7c0846105a.svg";
export { ForwardRef as ReactComponent };